import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {account_icon_by_slug} from '@bitstillery/common/lib/account'
import {classes} from '@bitstillery/common/lib/utils'
import {format_iso_to_date, format_money_with_symbol} from '@bitstillery/common/lib/format'
import {$t} from '@bitstillery/common/app'

import {$s} from '@/app'

export interface OrderSummaryAttrs {
    /** Header text — e.g. "S14485" on the overview or "Order nr. S14485" on the detail page. */
    reference: string
    status: {label: string; type: string}
    created_on: string
    bottles: number
    cases: number
    total_value: string | number
    currency: string
    /** Renders the account icon in the header when provided. */
    account_slug?: string
    /** Action buttons (downloads, repeat, ...) anchored at the end of the stats row. */
    actions?: m.Children
    /** Makes the whole widget clickable (used for navigation on the overview). */
    onclick?: () => void
}

export class OrderSummary extends MithrilComponent<OrderSummaryAttrs> {
    view(vnode: m.Vnode<OrderSummaryAttrs>) {
        const {reference, status, created_on, bottles, cases, total_value, currency, account_slug, actions, onclick} = vnode.attrs

        return (
            <div className={classes('c-order-summary', `status-${status.type}`, {clickable: !!onclick})} onclick={onclick}>
                <div className='summary-header'>
                    {account_slug && <span className='card-icon'>{account_icon_by_slug(account_slug)}</span>}
                    <span className='reference'>{reference}</span>
                    <label className={`label ${status.type}`}>{status.label}</label>
                </div>
                <div className='summary-body'>
                    <div className='stat stat-date'>
                        <span className='stat-label'>{$t('order.details.date')}</span>
                        <span className='stat-value'>{format_iso_to_date(created_on, $s.language)}</span>
                    </div>
                    <div className='stat stat-quantity'>
                        <span className='stat-label'>{$t('order.details.quantity')}</span>
                        <span className='stat-value'>
                            {bottles} btl · {cases} cs
                        </span>
                    </div>
                    <div className='stat stat-total'>
                        <span className='stat-label'>{$t('order.details.total_value')}</span>
                        <span className='stat-value'>{format_money_with_symbol(total_value, currency)}</span>
                    </div>
                    {actions && <div className='summary-actions'>{actions}</div>}
                </div>
            </div>
        )
    }
}
